/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0773e1aa303721a518d007607e004baf26f830fb";
